import React, { FC } from 'react';
import HLModal, { HLModalSizeType } from '../../shared/components/modal/HLModal';
import HLButton, { HLButtonStyleType } from '../../shared/components/button/HLButton';
import { switchStudentStatusFetch } from "../../app/axios/studentFetches";
import { StudentView } from "../../shared/types/student";

interface DeleteStudentModalProps {
    open: boolean,
    student: StudentView | null,
    onClose: () => void;
}


const SwitchStudentModal: FC<DeleteStudentModalProps> = (
    {
        open,
        student,
        onClose
    }) => {

    const switchStudentStatus = async () => {
        if (!student) return
        try {
            await switchStudentStatusFetch(student.id);
            onClose()
        } catch (err) {
            console.error('Ошибка при удалении урока:', err);
        }
    }

    if (!student) return null

    return (
        <HLModal
            open={open}
            onClose={onClose}
            title={`${!student.enabled ? 'Активирование' : 'Деактивирование'} ученика`}
            sizeType={HLModalSizeType.SMALL}
        >
            <div className="columnContainer">
                <h3>{`Вы уверены, что хотите ${!student.enabled ? 'активировать' : 'деактивировать'} ученика?`}</h3>
                <div className="inlineContainer">
                    <HLButton type="submit" onClick={switchStudentStatus}>Да</HLButton>
                    <HLButton type="button" onClick={onClose} styleType={HLButtonStyleType.GRAY}>Нет</HLButton>
                </div>
            </div>
        </HLModal>
    );
};

export default SwitchStudentModal;